export default __webpack_public_path__ + "static/media/share_preview.7812c91d.svg";